import wrapper from 'wrapper';

class InputHandler {
    constructor(region) {
        this.dropdown = wrapper.select('.regions-dropdown');
        this.dropdown.addEventListener('change', (evt) => {
            const { value } = evt.target.options[evt.target.selectedIndex]; /* eslint no-param-reassign: "error" */
            window.dispatchEvent(new CustomEvent('updated-filter', { detail: value }));
        });
        if (region) {
            this.setRegion(region);
        }
    }

    setRegion(region) {
        for (let i = 0; i < this.dropdown.options.length; i++) {
            const option = this.dropdown.options[i];
            if (option.value === region) {
                this.dropdown.selectedIndex = i;
                window.dispatchEvent(new CustomEvent('updated-filter', { detail: region }));
                return;
            }
        }
    }
}

export default InputHandler;
